export const CalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.33325V2.66659M4 1.33325V2.66659"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99667 8.66675H8.00267M7.99667 11.3334H8.00267M10.6603 8.66675H10.6663M5.33301 8.66675H5.33899M5.33301 11.3334H5.33899"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33301 5.33325H13.6663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66699 8.16213C1.66699 5.25729 1.66699 3.80485 2.50174 2.90243C3.33649 2 4.67999 2 7.36699 2H8.63366C11.3207 2 12.6642 2 13.4989 2.90243C14.3337 3.80485 14.3337 5.25729 14.3337 8.16213V8.50453C14.3337 11.4094 14.3337 12.8618 13.4989 13.7643C12.6642 14.6667 11.3207 14.6667 8.63366 14.6667H7.36699C4.67999 14.6667 3.33649 14.6667 2.50174 13.7643C1.66699 12.8618 1.66699 11.4094 1.66699 8.50453V8.16213Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 5.33325H14"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
